import React from "react";

function GercelSayilarinIslemOzellikleriIntro() {
  return <div>GercelSayilarinIslemOzellikleriIntro</div>;
}

export default GercelSayilarinIslemOzellikleriIntro;
